module.exports = __webpack_public_path__ + "media/backgrounds/nunzio-guerrera-9HnW4qYFE0o-unsplash-7a770610.jpg";